import store from '../../src/store';

export class TranslationService {
  private static langOptions = [ 
    { value: 'en', text: 'English'},
    { value: 'hi', text: 'Hindi'},
    { value: 'ne', text: 'Nepali'},
    { value: 'si', text: 'Sinhala'},
    { value: 'ar', text: 'Arabic'}
  ]
  private static translations = {
    en: {
      "select_factory_ticket": "Select Factory Ticket",
      "select_process": "Select Process",
      "production_entry_details": "Production Entry Details",
      "main_order_details": "Main Order Details",
      "order_no": "Order #",
      "factory_ticket_no": "Factory Ticket #",
      "order_date": "Order Date",
      "delivery_date": "Delivery Date",
      "product_line": "Product Line",
      "customer_name": "Customer Name",
      "item_no": "Item Code",
      "item_description": "Item Description",
      "selling_unit": "Selling Unit",
      "order_quantity": "Order Quantity",
      "produced_quantity": "Produced Quantity",
      "balance_quantity": "Balance Quantity",
      "production_status": "Production Status",
      "unit_wt_kg": "Unit Wt(KG)",
      "order_wt_kg": "Order Wt(KG)",
      "type": "Type",
      "shape": "Shape",
      "base_length": "Base Length",
      "base_width": "Base WIDTH",
      "total_paper_length": "Total Paper Length",
      "repeat": "REPEAT",
      "total_paper_width": "Total Paper WIDTH",
      "gsm": "GSM",
      "paper_type": "Paper Type",
      "material_color": "Material Color",
      "sachet_gsm": "Sachet GSM",
      "sachet_structure": "Sachet Structure",
      "tissue_gsm": "Tissue GSM",
      "tissue_length": "Tissue Length",
      "tissue_width": "Tissue Width",
      "fragrance": "Fragrance",
      "base_dia": "Base Dia",
      "upper_dia": "Upper Dia",
      "dia": "Dia",
      "height": "Height",
      "no_of_teeth": "# of Teeth",

      "search_machine": "Search Machine",
      "number_of_men": "Number of Men",
      "standard_speed": "Standard Speed",
      "active_speed": "Active Speed",
      "setup_dt": "Setup DT",
      "maintenance_dt": "Maintenance DT",
      "production_dt": "Production DT",
      "hour_meter_start": "Hour Meter Start",
      "hour_meter_end": "Hour Meter End",
      "setup_waste": "Setup Waste",
      "maintenance_waste": "Maintenance Waste",
      "trim_waste": "Trim Waste",
      "production_waste": "Production Waste",
      "production_date": "Production Date",
      "time_from": "Time From",
      "time_to": "Time To",
      "total_hours": "Total Hours",
      "quantity": "Quantity",
      "Volume Rebate": "Volume Rebate",
      "Discount": "Special Discount",
      "Check": "Check",
      "Transfer": "Transfer",
      "Cash": "Cash"
    },

    // Hindi
    "hi": {
      "select_factory_ticket": "फ़ैक्टरी टिकट चुनें",
      "select_process": "प्रक्रिया का चयन करें",
      "production_entry_details": "उत्पादन प्रविष्टि विवरण",
      "main_order_details": "मुख्य आदेश विवरण",
      "order_no": "आदेश #",
      "factory_ticket_no": "फ़ैक्टरी टिकट #",
      "order_date": "आदेश की तारीख",
      "delivery_date": "डिलीवरी की तारीख",
      "product_line": "उत्पाद रेखा",
      "customer_name": "कटोमर का नाम",
      "item_no": "मद संख्या।",
      "item_description": "आइटम विवरण",
      "selling_unit": "बिक्री इकाई",
      "order_quantity": "आदेश की मात्रा",
      "produced_quantity": "उत्पादित मात्रा",
      "production_status": "उत्पादित स्थिति",
      "balance_quantity": "शेष राशि",
      "unit_wt_kg": "यूनिट डब्ल्यूटी (केजी)",
      "order_wt_kg": "आदेश डब्ल्यूटी (केजी)",
      "type": "प्रकार",
      "shape": "आकार",
      "base_length": "आधार लंबाई",
      "base_width": "आधार चौड़ाई",
      "total_paper_length": "कुल कागज की लंबाई",
      "repeat": "दोहराना",
      "total_paper_width": "कुल पेपर WIDTH",
      "gsm": "जीएसएम",
      "paper_type": "कागज़ का प्रकार",
      "material_color": "सामग्री का रंग",
      "sachet_gsm": "पाउच जीएसएम",
      "sachet_structure": "पाउच संरचना",
      "tissue_gsm": "ऊतक जीएसएम",
      "tissue_length": "ऊतक की लंबाई",
      "tissue_width": "ऊतक चौड़ाई",
      "fragrance": "खुशबू",
      "base_dia": "बेस दीया",
      "upper_dia": "ऊपरी दीया",
      "dia": "व्यास",
      "height": "कद",
      "no_of_teeth": "#दांतों का",

      "search_machine": "खोज मशीन",
      "number_of_men": "पुरुषों की संख्या",
      "standard_speed": "मानक गति",
      "active_speed": "सक्रिय गति",
      "setup_dt": "सेटअप डीटी",
      "maintenance_dt": "रखरखाव डीटी",
      "production_dt": "उत्पादन डीटी",
      "hour_meter_start": "घंटा मीटर प्रारंभ",
      "hour_meter_end": "घंटा मीटर अंत",
      "setup_waste": "सेटअप अपशिष्ट",
      "maintenance_waste": "रखरखाव अपशिष्ट",
      "trim_waste": "ट्रिम अपशिष्ट",
      "production_waste": "उत्पादन अपशिष्ट",
      "production_date": "उत्पादन की तिथि",
      "time_from": "समय से",
      "time_to": "करने के लिए समय",
      "total_hours": "कुल घंटे",
      "quantity" : "मात्रा"
    },

    // Nepali
    "ne": {
      "select_factory_ticket": "कारखाना टिकट चयन गर्नुहोस्",
      "select_process": "प्रक्रिया चयन गर्नुहोस्",
      "production_entry_details": "उत्पादन प्रविष्टि विवरण",
      "main_order_details": "मुख्य आदेश विवरण",
      "order_no": "आदेश #",
      "factory_ticket_no": "कारखाना टिकट #",
      "order_date": "आदेश मिति",
      "delivery_date": "वितरण दिन",
      "product_line": "उत्पादन लाइन",
      "customer_name": "ग्राहकको नाम",
      "item_no": "बस्तु संख्या।",
      "item_description": "आइटम विवरण",
      "selling_unit": "बेच्ने एकाई",
      "order_quantity": "आदेश मात्रा",
      "produced_quantity": "उत्पादन मात्रा",
      "production_status": "उत्पादन स्थिति",
      "balance_quantity": "ब्यालेन्स मात्रा",
      "unit_wt_kg": "एकाइ वजन (केजी)",
      "order_wt_kg": "अर्डर वजन (केजी)",
      "type": "प्रकार",
      "shape": "आकार",
      "base_length": "आधार लम्बाइ",
      "base_width": "आधार चौडाई",
      "total_paper_length": "कुल कागज लम्बाई",
      "repeat": "दोहोर्याउनुहोस्",
      "total_paper_width": "कुल कागज चौडाई",
      "gsm": "जीएसएम",
      "paper_type": "कागज प्रकार",
      "material_color": "सामग्री रंग",
      "sachet_gsm": "Sachet जीएसएम",
      "sachet_structure": "Sachet संरचना",
      "tissue_gsm": "ऊतक जीएसएम",
      "tissue_length": "ऊतक लम्बाइ",
      "tissue_width": "ऊतक चौडाई",
      "fragrance": "सुगन्ध",
      "base_dia": "बेस दीया",
      "upper_dia": "माथिल्लो दीया",
      "dia": "दीया",
      "height": "उचाइ",
      "no_of_teeth": "दाँत को संख्या",
      "search_machine": "खोज मेसिन",
      "number_of_men": "पुरुषहरुको संख्या",
      "standard_speed": "मानक गति",
      "active_speed": "सक्रिय गति",
      "setup_dt": "सेटअप डीटी",
      "maintenance_dt": "मर्मत डेल्टा समय",
      "production_dt": "उत्पादन डेल्टा समय",
      "hour_meter_start": "घण्टा मीटर सुरु",
      "hour_meter_end": "घण्टा मीटर अन्त्य",
      "setup_waste": "अपशिष्ट सेटअप गर्नुहोस्",
      "maintenance_waste": "मर्मत फोहोर",
      "trim_waste": "फोहोर ट्रिम गर्नुहोस्",
      "production_waste": "उत्पादन फोहोर",
      "production_date": "उत्पादन मिति",
      "time_from": "बाट समय",
      "time_to": "समय भयो",
      "total_hours": "कुल घण्टा",
      "quantity" : "मात्रा"
    },

    // Sinhala - Sri Lanka
    "si": {
      "select_factory_ticket": "කර්මාන්තශාලා ටිකට් තෝරන්න",
      "select_process": "ක්‍රියාවලිය තෝරන්න",
      "production_entry_details": "නිෂ්පාදන ඇතුළත් වීමේ විස්තර",
      "main_order_details": "ප්‍රධාන ඇණවුම් විස්තර",
      "order_no": "නියෝග #",
      "factory_ticket_no": "කර්මාන්තශාලා ටිකට් #",
      "order_date": "ඇණවුම් දිනය",
      "delivery_date": "බෙදාහැරීමේ දිනය",
      "product_line": "නිෂ්පාදන රේඛාව",
      "customer_name": "පාරිභෝගිකයාගේ නම",
      "item_no": "අයිතමය අංකය",
      "item_description": "අයිතම විස්තරය",
      "selling_unit": "අලෙවි ඒකකය",
      "order_quantity": "ඇණවුම් ප්‍රමාණය",
      "produced_quantity": "නිපදවන ප්රමාණය",
      "production_status": "නිෂ්පාදන තත්ත්වය",
      "balance_quantity": "ශේෂ ප්රමාණය",
      "unit_wt_kg": "ඒකක බර (KG)",
      "order_wt_kg": "ඇණවුම් බර (KG)",
      "type": "ටයිප් කරන්න",
      "shape": "හැඩය",
      "base_length": "පාදක දිග",
      "base_width": "පළල පළල",
      "total_paper_length": "මුළු කඩදාසි දිග",
      "repeat": "නැවත නැවත කරන්න",
      "total_paper_width": "මුළු කඩදාසි පළල",
      "gsm": "ජීඑස්එම්",
      "paper_type": "කඩදාසි වර්ගය",
      "material_color": "ද්රව්ය වර්ණය",
      "sachet_gsm": "සැචෙට් ජීඑස්එම්",
      "sachet_structure": "සැචෙට් ව්යුහය",
      "tissue_gsm": "පටක ජීඑස්එම්",
      "tissue_length": "පටක දිග",
      "tissue_width": "පටක පළල",
      "fragrance": "සුවඳ විලවුන්",
      "base_dia": "මූලික ඩියා",
      "upper_dia": "ඉහළ ඩියා",
      "dia": "ඩියා",
      "height": "උස",
      "no_of_teeth": "දත් ගණන",
      "search_machine": "යන්ත්රය සොයන්න",
      "number_of_men": "පිරිමි ගණන",
      "standard_speed": "සම්මත වේගය",
      "active_speed": "ක්රියාකාරී වේගය",
      "setup_dt": "ඩීටී සකසන්න",
      "maintenance_dt": "නඩත්තු ඩෙල්ටා කාලය",
      "production_dt": "නිෂ්පාදන ඩෙල්ටා කාලය",
      "hour_meter_start": "පැය මිටර් ආරම්භය",
      "hour_meter_end": "පැය මීටර අවසන්",
      "setup_waste": "අපද්රව්ය සකසන්න",
      "maintenance_waste": "නඩත්තු අපද්රව්ය",
      "trim_waste": "කසළ කපන්න",
      "production_waste": "නිෂ්පාදන අපද්රව්ය",
      "production_date": "නිෂ්පාදිත දිනය",
      "time_from": "සිට කාලය",
      "time_to": "කිරීමට කාලය",
      "total_hours": "මුළු පැය",
      "quantity" : "ප්රමාණය"
    },

    // Arabic
    "ar": {
      "select_factory_ticket":  "حدد تذكرة المصنع",
      "select_process":  "حدد العملية",
      "production_entry_details":  "تفاصيل دخول الإنتاج",
      "main_order_details":  "تفاصيل الطلب الرئيسي",
      "order_no":  "طلب #",
      "factory_ticket_no": "تذكرة المصنع #",
      "order_date":  "تاريخ الطلب",
      "delivery_date": "تاريخ التسليم او الوصول",
      "product_line":  "خط الانتاج",
      "customer_name":  "اسم الزبون",
      "item_no":  "رقم الصنف.",
      "item_description":  "وصف السلعة",
      "selling_unit":  "وحدة البيع",
      "order_quantity":  "كمية الطلب",
      "produced_quantity": "الكمية المنتجة",
      "production_status": "وضع الإنتاج",
      "balance_quantity":  "كمية التوازن",
      "unit_wt_kg":  "وزن الوحدة (كجم)",
      "order_wt_kg":  "وزن الطلب (كجم)",
      "type":  "اكتب",
      "shape":  "شكل",
      "base_length":  "طول القاعدة",
      "base_width":  "عرض القاعدة",
      "total_paper_length":  "إجمالي طول الورق",
      "repeat":  "كرر",
      "total_paper_width":  "إجمالي عرض الورق",
      "gsm":  "GSM",
      "paper_type":  "نوع الورق",
      "material_color":  "لون المادة",
      "sachet_gsm":  "الكيس GSM",
      "sachet_structure":  "هيكل الكيس",
      "tissue_gsm":  "GSM الأنسجة",
      "tissue_length":  "طول الأنسجة",
      "tissue_width":  "عرض الأنسجة",
      "fragrance":  "العطر",
      "base_dia":  "قاعدة ضياء",
      "upper_dia":  "العليا ديا",
      "dia":  "ضياء",
      "height":  "ارتفاع",
      "no_of_teeth":  "عدد الاسنان",
      "search_machine":  "آلة البحث",
      "number_of_men":  "عدد الرجال",
      "standard_speed":  "السرعة القياسية",
      "active_speed":  "السرعة النشطة",
      "setup_dt":  "إعداد DT",
      "maintenance_dt":  "وقت الصيانة دلتا",
      "production_dt":  "توقيت دلتا للإنتاج",
      "hour_meter_start":  "ساعة بدء العداد",
      "hour_meter_end":  "ساعة عداد نهاية",
      "setup_waste":  "إعداد النفايات",
      "maintenance_waste":  "نفايات الصيانة",
      "trim_waste":  "تقليم النفايات",
      "production_waste":  "نفايات الإنتاج",
      "production_date":  "تاريخ الإنتاج",
      "time_from":  "الوقت من",
      "time_to":  "وقت ل",
      "total_hours":  "مجموع الساعات",
      "quantity" : "كمية",
      "Volume Rebate": "خصم الحجم",
      "Discount": "تخفيض",
      "Check": "شيك",
      "Transfer": "حوالة",
      "Cash": "نقدي"
    }
  }

  static translate(key: string, languageOption?: string) {
    const languageKey = languageOption || store.state.language;
    const language : any = (TranslationService.translations as any)[languageKey]
    if (language == null) {
      throw new Error(`Language "${languageKey}" not found`)
    }
    const text = language[key]
    if (text == null) {
      throw new Error(`Key "${key}" not found in "${languageKey}"`)
    }
    return text;
  }

  static translateLangOptions(): { value: string, text: string}[] {
    return TranslationService.langOptions;
  }
}